export default __webpack_public_path__ + "static/media/Twitter-Logo-White.08ef48a0.svg";